import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Like = ({ likeable, likeableType, createLikeForLikeable, destroyLikeForLikeable, fetchUsers }) => {
  const [likedByCurrentUser, setLikedByCurrentUser] = useState(likeable.likedByCurrentUser);
  const [likesCount, setLikesCount] = useState(likeable.likesCount || 0);
  const [showUsers, setShowUsers]   = useState(false);
  const [usersState, setUsersState] = useState({
    fetching: false,
    fetched:  false,
    userList: []
  });

  const { fetching, fetched, userList } = usersState;

  useEffect(() => {
    if (showUsers) {
      getUserList();
    }
  }, [showUsers]);

  const toggleCurrentUserLike = () => {
    if (likedByCurrentUser) {
      destroyLikeForLikeable(likeable, likeableType, handleLikeDestroyResponse);
    } else {
      createLikeForLikeable(likeable, likeableType, handleLikeCreateResponse);
    }
  }

  const handleLikeDestroyResponse = action => {
    const { decrement } = action;

    setLikedByCurrentUser(false);

    if (decrement) {
      setLikesCount(likesCount - 1);
    }
  }

  const handleLikeCreateResponse = action => {
    const { increment } = action;

    setLikedByCurrentUser(true);

    if (increment) {
      setLikesCount(likesCount + 1);
    }
  }

  const getUserList = () => {
    if (fetched || fetching || !likesCount) { return; }

    const fetchingState = { fetching: true, fetched: false };
    const fetchedState = { fetching: false, fetched: true };

    setUsersState(Object.assign({}, usersState, fetchingState));

    fetchUsers(likeable, likeableType).then(users => {
      setUsersState(Object.assign({}, fetchedState, { userList: users }));
    });
  }

  const renderUserList = () => {
    if (!userList.length) { return; }

    return (
      <span className="liked-by-container">
        <ul className="liked-by-list">
          <li>Liked by:</li>
          {
            userList.map(user => {
              return <li key={ user[0] }><a href={ `/users/${user[0]}` }>{ [user[1], user[2]].join(' ') }</a></li>
            })
          }
        </ul>
      </span>
    );
  }

  const likesClass = ['mr-40'];
  if (likedByCurrentUser) {
    likesClass.push('highlighted');
  }
  const likesText = `${likesCount || ''} ${likesCount > 1 ? 'Likes' : 'Like'}`;

  return (
    <span
      className="like-container"
      onMouseEnter={ () => { setShowUsers(true); } }
      onMouseLeave={ () => { setShowUsers(false); } }>
      <a className={ likesClass.join(' ') }
         onClick={ toggleCurrentUserLike }>
         { likesText }
      </a>
      { showUsers && renderUserList() }
    </span>
  );
};

Like.propTypes = {
  likeable: PropTypes.object.isRequired
};

export default Like;
